import { z } from "zod";

export const opportunityFormSchema = z.object({
  owner: z.number({ message: "Selecione o responsável" }),
  channel: z.number({ message: "Selecione o canal" }),
  stage: z.number({ message: "Selecione a etapa" }),
  mrr_estimated: z.number().min(0, "Deve ser maior ou igual a zero"),
  non_recurring_estimated: z.number().min(0, "Deve ser maior ou igual a zero"),
});

export type OpportunityFormData = z.infer<typeof opportunityFormSchema>;

export const newCompanySchema = z.object({
  name: z.string().min(1, "Informe o nome da empresa"),
  cnpj: z.string(),
  website: z.string(),
});

export const newContactSchema = z.object({
  name: z.string().min(1, "Informe o nome do contato"),
  email: z.string(),
  phone: z.string(),
  role: z.string(),
});
